// extracted by mini-css-extract-plugin
export var attachButton = "_lv-8";
export var sendButton = "_lv-2";
export var sendDisabled = "_lv-4";
export var sendEnabled = "_lv-3";
export var sendIcon = "_lv-6";
export var sendIconDisabled = "_lv-7";
export var sendStreaming = "_lv-5";
export var textarea = "_lv-1";
export var wrapper = "_lv-0";